module.exports = __webpack_public_path__ + "assets/img/block-6194f89e.png";